import { isAxiosError } from 'axios';
import { AccessTokenValidatorError, Container } from '@utils-global';
import { routes } from '../constants';

export const validateAccessToken = async (
  accessToken: string,
): Promise<{
  graphToken: string;
}> => {
  try {
    const res = await Container.accessTokenValidatorClient.get(
      routes.accessTokenValidator.validate,
      {
        headers: {
          Authorization: accessToken,
        },
        params: {
          environment: process.env.TARGET_ENV,
        },
      },
    );

    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      const data = error.response?.data;
      throw new AccessTokenValidatorError({
        // If available, flatten the validator's failure response into the error context.
        ...(data && typeof data === 'object' ? data : { data }),
        status: error.response?.status,
      });
    }

    throw error;
  }
};
